/** Registers the Control parser for Range. `index.r3f.ts` registers its painter. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseControl } from '../../../2d/ui/control/parser';
const rangeRegistration = {
    typeName: 'Range',
    parser: parseControl,
};
nodeRegistry.register(rangeRegistration);
//# sourceMappingURL=index.js.map